/* eslint-disable you-dont-need-momentjs/is-same */
/* eslint-disable you-dont-need-momentjs/format */
/* eslint-disable you-dont-need-momentjs/no-moment-constructor */
/* eslint-disable no-param-reassign */
import moment from 'moment'
import { combineReducers } from 'redux'

import {
  getCountOfWorkingDays,
  getWeekendDays,
  LAUNCH_TIME_FORMAT,
  WIZARD_DATE_FORMAT,
} from 'utils/dateUtils'

import {
  CAMPAIGN_TYPES_VALUES,
  DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
  DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  DELIVERY,
  LEVEL_VALUES,
  PARTICIPANTS_GROUP_KEYS,
} from 'containers/AwarenessCenter/constants'
import { SAVE_SCENARIO_ASYNC } from 'containers/ScenarioForm/constants'

import {
  CHANGE_CLOSE_TIME,
  CHANGE_DEFAULT_LOCALE_ID,
  CHANGE_DELIVERY,
  CHANGE_END_DATE,
  CHANGE_MAX_EMAIL_PER_DAY,
  CHANGE_PARTICIPANTS_SELECTION,
  CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  GET_CAMPAIGN_ASYNC,
  RESET_CAMPAIGN_TYPE_FLAGS,
  SENDING_VALUES,
  TOGGLE_LANDING_PAGE,
  TOGGLE_RANDOMIZED,
  TOGGLE_SCENARIO,
  TOGGLE_SEND_ALL_WEEK,
  TOGGLE_SENDING_TYPE,
  TOGGLE_TOURNAMENT,
  TOGGLE_TRAINING_VIDEO,
} from '../steps/constants'
import landingPageStepReducer from '../steps/LandingPageStep/reducer'
import { wizardHandlers } from '../steps/reducer'
import reviewAndLaunchStepReducer from '../steps/ReviewAndLaunchStep/reducer'
import { AUTO_SELECT_SCENARIOS_ASYNC, AUTO_SELECT_VALUES } from '../steps/ScenariosStep/constants'
import scenariosStepReducer from '../steps/ScenariosStep/reducer'
import {
  GET_PARTICIPANTS_ASYNC,
  SUBMIT_QUICK_LAUNCH_ASYNC,
  VALIDATE_SETUP_STEP,
} from '../steps/SetupStep/constants'
import setupStepReducer from '../steps/SetupStep/reducer'
import {
  AUTOMATED_LEVEL_BASED_TRAINING,
  CUSTOM_MODULE_IMAGE_PREVIEW,
  CUSTOM_MODULE_NAME_FILE,
  CUSTOM_MODULE_NAME_URL,
  CUSTOM_MODULE_TYPES,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
} from '../steps/TrainingModuleStep/constants'
import trainingModuleStepReducer from '../steps/TrainingModuleStep/reducer'
import { mapCompletionNotificationSettingsFromApi } from '../steps/utils'

import {
  CHANGE_LOCALES_BY_PROFILES,
  CHANGE_SELECTED_LOCALE_IDS,
  DEFAULT_SIMULATION_CAMPAIGN_OBJECT,
} from './constants'
import {
  getSimulationCampaignLaunchProperties,
  mapSimulationValidatorByName,
  nextPreservePersistedMaxEmailPerDay,
} from './utils'

const handlers = {
  [RESET_CAMPAIGN_TYPE_FLAGS]: (state) => ({
    ...state,
    isQuickLaunch: false,
    editMode: false,
  }),
  [VALIDATE_SETUP_STEP]: (state) => ({
    ...state,
    validation: {
      ...state.validation,
      name: mapSimulationValidatorByName.name(state.campaign.name),
      launchDate: mapSimulationValidatorByName.launchDate(state.campaign.launchDate),
      endDate: mapSimulationValidatorByName.endDate(state.campaign.endDate),
      closeTime: mapSimulationValidatorByName.closeTime(
        state.campaign.closeTime,
        state.campaign.endDate
      ),
      launchTime: mapSimulationValidatorByName.launchTime(
        state.campaign.launchTime,
        state.campaign.launchDate,
        state.campaign.timezone,
        state.campaign.randomized
      ),
    },
  }),
  [CHANGE_DEFAULT_LOCALE_ID]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      defaultLocaleId: payload.value,
      selectedScenarios: [],
      selectedLandingPage: {},
      selectedTrainingVideo: [],
      selectedLocaleIds: [],
    },
  }),
  [CHANGE_SELECTED_LOCALE_IDS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedLocaleIds: payload.value,
    },
  }),
  [TOGGLE_TOURNAMENT]: (state) => ({
    ...state,
    campaign: {
      ...state.campaign,
      isTournament: !state.campaign.isTournament,
    },
  }),
  [CHANGE_PARTICIPANTS_SELECTION]: (state, { payload }) => {
    const participantsData = {
      ...state.campaign.participants,
      selectorLoader: true,
    }

    if (
      payload.key === PARTICIPANTS_GROUP_KEYS.INCLUDED &&
      Object.values(payload.value).length === 0
    ) {
      // cleared selected, clear also excluded
      participantsData.excluded = {}
      participantsData.meta = {
        awarenessLevels: {
          [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
          [LEVEL_VALUES.MID_LEVEL]: 0,
          [LEVEL_VALUES.EXPERT_LEVEL]: 0,
        },
        localeIds: [],
        count: 0,
      }
    }

    participantsData[payload.key] = payload.value

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedScenarios: [],
        selectedLandingPage: {},
        selectedTrainingVideo: [],
        participants: participantsData,
        ...getSimulationCampaignLaunchProperties(
          state,
          {
            maxEmailPerDay: state.campaign.maxEmailPerDay,
            participantsCount: participantsData.meta.count,
          },
          // forceCalculation only if maxEmailPerDay not Unlimited
          !!state.campaign.maxEmailPerDay
        ),
        preservePersistedMaxEmailPerDay: false,
      },
    }
  },
  [CHANGE_PARTICIPANTS_TOTAL_SELECTION]: (state, { payload }) => {
    const participantsData = {
      ...state.campaign.participants,
      selectorLoader: true,
    }

    if (Object.values(payload.data.included).length === 0) {
      // cleared selected, clear also excluded
      participantsData.excluded = {}
      participantsData.meta = {
        awarenessLevels: {
          [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
          [LEVEL_VALUES.MID_LEVEL]: 0,
          [LEVEL_VALUES.EXPERT_LEVEL]: 0,
        },
        localeIds: [],
        count: 0,
      }
    } else {
      participantsData.excluded = payload.data.excluded
    }

    participantsData.included = payload.data.included

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedScenarios: [],
        selectedLandingPage: {},
        selectedTrainingVideo: [],
        participants: participantsData,
        ...getSimulationCampaignLaunchProperties(
          state,
          {
            maxEmailPerDay: state.campaign.maxEmailPerDay,
            participantsCount: participantsData.meta.count,
          },
          // forceCalculation only if maxEmailPerDay not Unlimited
          !!state.campaign.maxEmailPerDay
        ),
        preservePersistedMaxEmailPerDay: false,
      },
    }
  },
  [CHANGE_MAX_EMAIL_PER_DAY]: (state, { payload }) => {
    // FR-2: once the admin edits this field manually, its value becomes authoritative
    // and the smart default (FR-4) stops overwriting it on recalculation.
    const stateWithManualFlag = {
      ...state,
      campaign: {
        ...state.campaign,
        isMaxEmailPerDayWasManuallyChanged: true,
        preservePersistedMaxEmailPerDay: false,
      },
    }

    return {
      ...state,
      campaign: {
        ...stateWithManualFlag.campaign,
        ...getSimulationCampaignLaunchProperties(stateWithManualFlag, {
          maxEmailPerDay: payload.value,
        }),
      },
    }
  },
  [CHANGE_DELIVERY]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      ...getSimulationCampaignLaunchProperties(state, {
        delivery: payload.value,
      }),
      selectedScenarios: [],
      participants: {
        ...state.campaign.participants,
        selectorLoader: true,
        error: null,
        meta: {
          awarenessLevels: {
            [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
            [LEVEL_VALUES.MID_LEVEL]: 0,
            [LEVEL_VALUES.EXPERT_LEVEL]: 0,
          },
          localeIds: [],
          count: 0,
          included: {},
          excluded: {},
        },
      },
    },
  }),
  [CHANGE_END_DATE]: (state, { payload }) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      endDate: payload.value,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        endDate: mapSimulationValidatorByName.endDate(campaignLaunchProperties.endDate),
      },
    }
  },
  [CHANGE_CLOSE_TIME]: (state, { payload }) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      closeTime: payload.value,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        closeTime: mapSimulationValidatorByName.closeTime(
          campaignLaunchProperties.closeTime,
          campaignLaunchProperties.endDate
        ),
      },
    }
  },
  [TOGGLE_RANDOMIZED]: (state) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      randomized: !state.campaign.randomized,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        launchTime: mapSimulationValidatorByName.launchTime(
          campaignLaunchProperties.launchTime,
          campaignLaunchProperties.launchDate,
          state.campaign.timezone,
          campaignLaunchProperties.randomized
        ),
      },
    }
  },
  [TOGGLE_SEND_ALL_WEEK]: (state) => {
    const campaignLaunchProperties = getSimulationCampaignLaunchProperties(state, {
      sendAllWeek: !state.campaign.sendAllWeek,
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        launchTime: mapSimulationValidatorByName.launchTime(
          campaignLaunchProperties.launchTime,
          campaignLaunchProperties.launchDate,
          state.campaign.timezone,
          campaignLaunchProperties.randomized
        ),
      },
    }
  },
  [TOGGLE_SCENARIO]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedScenarios: payload.selected
        ? [...state.campaign.selectedScenarios.filter((s) => s.id !== payload.scenario.id)]
        : [...state.campaign.selectedScenarios, payload.scenario],
    },
  }),
  [TOGGLE_LANDING_PAGE]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedLandingPage: payload.selected ? {} : payload.landingPage,
    },
  }),
  [TOGGLE_TRAINING_VIDEO]: (state, { payload }) => {
    const selectedTrainingVideo = payload.selected
      ? state.campaign.selectedTrainingVideo.filter((s) => s.id !== payload.trainingVideo.id)
      : [...state.campaign.selectedTrainingVideo, payload.trainingVideo]

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedTrainingVideo,
      },
    }
  },
  [TOGGLE_SENDING_TYPE]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      randomizedScenarios: payload.type === SENDING_VALUES.RANDOMIZED,
      leveledScenarios: payload.type === SENDING_VALUES.LEVELED,
    },
  }),
  [GET_CAMPAIGN_ASYNC.SUCCESS]: (state, { payload }) => {
    payload.data.trainings = payload.data.trainings.filter((training) => !training.is_deleted)

    const name = payload.data.name
    const randomized = payload.data.randomized
    const sendAllWeek = payload.data.send_all_week
    const launchDate = moment(payload.data.schedule_time).format(WIZARD_DATE_FORMAT)
    const launchTime = randomized
      ? ''
      : moment(payload.data.schedule_time).format(LAUNCH_TIME_FORMAT)
    let endDate = moment(payload.data.end_date).format(WIZARD_DATE_FORMAT)
    if (!moment(endDate).isValid()) endDate = ''
    const closeTime = moment(payload.data.close_time).format(WIZARD_DATE_FORMAT)
    const timezone = payload.data.campaign_timezone
    let selectedTrainingVideo = []

    if (payload.data.trainings.length) {
      selectedTrainingVideo = payload.data.trainings
      selectedTrainingVideo = selectedTrainingVideo.map((video) => {
        const videoName =
          video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
            ? video.items[0]?.custom_type === CUSTOM_MODULE_TYPES.CUSTOM_VIDEO
              ? CUSTOM_MODULE_NAME_FILE
              : CUSTOM_MODULE_NAME_URL
            : video.name

        return {
          ...video,
          name: videoName,
          vendor: video.vendor || SOURCE_VALUES.CUSTOM_MODULE,
          items: video.items.map((item) => ({
            ...item,
            embeddedSubtitles: item.embedded_subtitles,
            localeId: item.locale,
            customType: item.custom_type,
            imagePreview:
              video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                ? CUSTOM_MODULE_IMAGE_PREVIEW
                : item.image_preview || '',
          })),
        }
      })
    } else {
      selectedTrainingVideo = [AUTOMATED_LEVEL_BASED_TRAINING]
    }

    return {
      ...state,
      campaign: {
        id: payload.data.id,
        participants: {
          ...state.campaign.participants,
          selectorLoader: true,
          included: payload.data.participants_choices || {},
          excluded: payload.data.participants_exclude_choices || {},
        },
        name,
        selectedLocaleIds: payload.data.locales,
        defaultLocaleId: payload.data.locale,
        isTournament: payload.data.is_tournament,
        timezone,
        maxEmailPerDay: payload.data.max_email_per_day,
        // Keep the API Emails/day on edit open (including the participants
        // re-fetch). Audience changes clear preservePersistedMaxEmailPerDay so
        // FR-4 can run; this is not a session-manual override (FR-2).
        isMaxEmailPerDayWasManuallyChanged: false,
        preservePersistedMaxEmailPerDay: !!payload.data.max_email_per_day,
        // An API end date is not a manual override. Keep this false so changing
        // participants on edit can still recalculate the delivery window.
        isEndDateWasManuallyChanged: false,
        status: payload.data.status,
        launchDate,
        launchTime,
        endDate,
        closeTime,
        sendRemindersUntil: payload.data.sendRemindersUntil,
        sendAllWeek,
        randomized: payload.data.randomized,
        delivery: DELIVERY[payload.data.delivery_type.toUpperCase()],
        sendingDays: getCountOfWorkingDays(
          moment(launchDate),
          moment(endDate),
          sendAllWeek ? [] : getWeekendDays(state.workdays)
        ),
        randomizedScenarios: payload.data.randomized_scenarios,
        leveledScenarios: !payload.data.randomized_scenarios,
        selectedScenarios: payload.data.scenarios || [],
        selectedLandingPage: payload.data.landing_page || {},
        selectedTrainingVideo,
        sendReminderEveryXBusinessDays: payload.data.sendReminderEveryXBusinessDays,
        campaignTemplateId: payload.data.campaign_template,
        localesByProfiles: payload.data.localesByProfiles,
        sendCampaignFailedEmail: payload.data.sendCampaignFailedEmail,
        sendCampaignSummaryToCampaignReportRecipients:
          payload.data.sendCampaignSummaryToCampaignReportRecipients,
        trainingReminders: payload.data.trainingReminders,
        notifications: payload.data.notifications,
        managerReportRemindersThreshold:
          payload.data.managerReportRemindersThreshold ||
          DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
        sendManagerReportEveryXDays: payload.data.sendManagerReportEveryXDays,
        managerReportDayOfWeek:
          payload.data.managerReportDayOfWeek || DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
        campaignManagerNotificationState: payload.data.managerNotificationState,
        managerNotificationBannerContent: payload.data.managerNotificationBanner?.text,
        managerReportEmailContentSubject: payload.data.managerReportEmail?.subject,
        managerReportEmailContent: payload.data.managerReportEmail?.body,
        triggerBasedCampaignData: payload.data.triggerBasedCampaignData,
        maxRemindersPerParticipant: payload.data.maxRemindersPerParticipant,
        completionNotificationSettings: mapCompletionNotificationSettingsFromApi(
          payload.data.completionNotificationSettings
        ),
      },
      validation: {
        ...state.validation,
        name: mapSimulationValidatorByName.name(name),
        launchDate: mapSimulationValidatorByName.launchDate(launchDate),
        endDate: mapSimulationValidatorByName.endDate(endDate),
        launchTime: mapSimulationValidatorByName.launchTime(
          launchTime,
          launchDate,
          timezone,
          randomized
        ),
        closeTime: mapSimulationValidatorByName.closeTime(closeTime, endDate),
      },
    }
  },
  [AUTO_SELECT_SCENARIOS_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedScenarios: payload.data,
      randomizedScenarios: payload.type === AUTO_SELECT_VALUES.RANDOMIZED,
      leveledScenarios: payload.type === AUTO_SELECT_VALUES.LEVELED,
    },
  }),
  [SUBMIT_QUICK_LAUNCH_ASYNC.INITIATE]: (state) => ({
    ...state,
    isQuickLaunch: true,
  }),
  [GET_PARTICIPANTS_ASYNC.SUCCESS]: (state, { payload }) => {
    const nextCount = payload.data.meta.count
    const preservePersistedMaxEmailPerDay = nextPreservePersistedMaxEmailPerDay(state, nextCount)
    const stateForCalc = {
      ...state,
      campaign: {
        ...state.campaign,
        preservePersistedMaxEmailPerDay,
      },
    }

    return {
      ...state,
      loader: false,
      campaign: {
        ...state.campaign,
        participants: {
          ...state.campaign.participants,
          modalLoader: false,
          selectorLoader: false,
          error: null,
          items: payload.data.items,
          meta: {
            awarenessLevels: {
              [LEVEL_VALUES.BEGINNER_LEVEL]: payload.data.meta.awarenessLevels.beginner,
              [LEVEL_VALUES.MID_LEVEL]: payload.data.meta.awarenessLevels.mid,
              [LEVEL_VALUES.EXPERT_LEVEL]: payload.data.meta.awarenessLevels.expert,
            },
            localeIds: payload.data.meta.localeIds,
            count: nextCount,
          },
        },
        ...getSimulationCampaignLaunchProperties(
          stateForCalc,
          {
            maxEmailPerDay: state.campaign.maxEmailPerDay,
            participantsCount: nextCount,
          },
          // forceCalculation only if maxEmailPerDay not Unlimited
          !!state.campaign.maxEmailPerDay
        ),
        preservePersistedMaxEmailPerDay,
      },
    }
  },
  [CHANGE_LOCALES_BY_PROFILES]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      localesByProfiles: payload.value,
      selectedScenarios: [],
      selectedLandingPage: {},
      selectedTrainingVideo: [],
    },
  }),
  [SAVE_SCENARIO_ASYNC.SUCCESS]: (state, { payload }) => {
    const selectedScenarios = state.campaign.selectedScenarios

    if (selectedScenarios.length) {
      const changedSelectedScenarioIndex = selectedScenarios.findIndex(
        ({ id }) => id === payload.data.id
      )

      if (changedSelectedScenarioIndex !== -1) {
        selectedScenarios[changedSelectedScenarioIndex] = {
          ...selectedScenarios[changedSelectedScenarioIndex],
          ...payload.data,
        }
      }
    }

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedScenarios,
      },
    }
  },
  DEFAULT: (state) => state,
}

export const initialState = {
  loader: false,
  error: null,
  validation: {},

  draftLoader: false,
  draftError: null,
  draftGotManaged: false,

  // workdays: 0 or 1, setting by PUT_WORKDAYS
  editMode: false, // might be changed by INIT_EDIT_MODE
  isQuickLaunch: false, // once Quick Launch generated the Campaign
  gotApproved: false, // once BE returning 200 for Approve becomes True and UI making redirect
  maxCampaignsAllowed: undefined,

  userProperties: {
    showQuickLaunchBTN: false,
    showQuickLaunchNotice: false,
    trainingContentVendors: [],
  },

  campaign: { ...DEFAULT_SIMULATION_CAMPAIGN_OBJECT },
}

const wizardCampaignReducer =
  () =>
  (state = initialState, action) => {
    const handle = wizardHandlers[action.type] || handlers[action.type] || handlers.DEFAULT

    return handle(state, action, CAMPAIGN_TYPES_VALUES.SIMULATION)
  }

export default function () {
  return combineReducers({
    self: wizardCampaignReducer(),
    scenariosStep: scenariosStepReducer(),
    landingPageStep: landingPageStepReducer(),
    trainingModuleStep: trainingModuleStepReducer(),
    setupStep: setupStepReducer(),
    reviewAndLaunchStep: reviewAndLaunchStepReducer(),
  })
}
